import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { initMetaPixel } from './utils/metaPixel';
import { InfoBar } from './components/InfoBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { HowItWorks } from './components/HowItWorks';
import { Audience } from './components/Audience';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
    document.documentElement.lang = 'nb';
    document.title = 'GOLFKLAR™ – Hele golfsesongen ferdig planlagt for golftrenere';
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3ii4s22026sok">
      <div lang="nb" className="w-full bg-stone-50 font-sans text-slate-900 antialiased" data-id="element-1" data-mp="3mkrc3gqhn9b7">
        <InfoBar data-id="element-2" data-mp="3rbrc4uuwm7hx" />
        <main data-id="element-3" data-mp="3rdarmj8qkein">
          <Hero data-id="element-4" data-mp="3rcsw5otwe4bs" />
          <StatsBar data-id="element-5" data-mp="3recedkz46pg7" />
          <Difference data-id="element-6" data-mp="5yhupa6n3cr" />
          <Recognize data-id="element-7" data-mp="67znpl2q47d" />
          <WhatsInside data-id="element-8" data-mp="4n6a3ahwrb3" />
          <InsidePages data-id="element-9" data-mp="82ld64660ci" />
          <Bonuses data-id="element-10" data-mp="2zl3cjn8vpa6d" />
          <HowItWorks data-id="element-11" data-mp="2zllijblcf2rh" />
          <Audience data-id="element-12" data-mp="2zmeo498kfm81" />
          <Offer data-id="element-13" data-mp="2zmwh8wzxlkbq" />
          <Guarantee data-id="element-14" data-mp="2zng1wlgyumtg" />
          <Faq data-id="element-15" data-mp="33m5b01uz1i7a" />
          <FinalCta data-id="element-16" data-mp="33lx18iu5at0b" />
        </main>
        <Footer data-id="element-17" data-mp="33myl9ct52pu6" />
      </div>
    </MotionConfig>;
}